import { render, staticRenderFns } from "./CustomerInviteList.vue?vue&type=template&id=1882520c&scoped=true"
import script from "./CustomerInviteList.vue?vue&type=script&lang=js"
export * from "./CustomerInviteList.vue?vue&type=script&lang=js"
import style0 from "./CustomerInviteList.vue?vue&type=style&index=0&id=1882520c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1882520c",
  null
  
)

export default component.exports